import type { User } from '@auth0/auth0-spa-js';
import { Auth0Client as RawAuth0Client } from '@auth0/auth0-spa-js';

class Auth0Client {
  private client: RawAuth0Client;

  constructor() {
    this.client = new RawAuth0Client({
      domain: import.meta.env.PROJECT_SERVICE_AUTH0_DOMAIN,
      clientId: import.meta.env.PROJECT_SERVICE_AUTH0_CLIENT_ID,
      authorizationParams: {
        redirect_uri: window.location.origin + import.meta.env.BASE_URL,
        audience: import.meta.env.PROJECT_SERVICE_AUTH0_AUDIENCE,
      },
    });
  }

  async subscribe(
    callback: (data: {
      isAuthenticated: boolean;
      userInfo: User | undefined;
      accessToken: string;
      idToken: string | undefined;
    }) => void,
  ) {
    const accessToken = await this.client.getTokenSilently();
    const isAuthenticated = await this.client.isAuthenticated();
    const tokenClaims = await this.client.getIdTokenClaims();
    const userInfo = await this.client.getUser();
    const idToken = tokenClaims?.__raw;

    callback({ isAuthenticated, userInfo, accessToken, idToken });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async start() {
    // no-op to match the interface of ProfilesClient
  }

  loginWithRedirect() {
    return this.client.loginWithRedirect();
  }

  async loginWithPopup() {
    return this.client.loginWithPopup();
  }

  async loginSilently() {
    return this.client.getTokenSilently();
  }
}

export const auth0Client = new Auth0Client();
